import React from 'react';
import SafeIcon from '../common/SafeIcon';

const PAGES_DATA = [
  { id: 1, title: 'Privacy Policy', path: '/privacy', date: 'Mar 24, 2026', status: 'Published' },
  { id: 2, title: 'Terms of Use', path: '/terms', date: 'Mar 24, 2026', status: 'Published' }
];

const Pages = () => {
  return (
    <div className="space-y-6 max-w-5xl">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Static Pages</h1>
          <p className="text-gray-500">Manage legal and informational pages.</p>
        </div>
        <button className="bg-[#11469A] hover:bg-[#0d3678] text-white px-6 py-2.5 rounded-lg flex items-center gap-2 font-bold text-sm shadow-sm transition-all">
          <SafeIcon name="Plus" size={18} /> Create Page
        </button>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {PAGES_DATA.map((page) => (
          <div key={page.id} className="card p-4 sm:p-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 group">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-gray-50 flex items-center justify-center text-gray-400 shrink-0">
                <SafeIcon name="FileText" size={20} />
              </div>
              <div>
                <div className="flex items-center gap-3 mb-1">
                  <h3 className="text-lg font-bold text-gray-800">{page.title}</h3>
                  <span className="px-2 py-0.5 rounded bg-green-50 text-green-600 text-[10px] font-bold uppercase tracking-wider">
                    {page.status}
                  </span>
                </div>
                <div className="flex items-center gap-4 text-sm text-gray-500">
                  <span className="flex items-center gap-1"><SafeIcon name="Link" size={14}/> {page.path}</span>
                  <span className="hidden sm:flex items-center gap-1"><SafeIcon name="Clock" size={14}/> Updated: {page.date}</span>
                </div>
              </div>
            </div>
            <div className="flex gap-2 w-full sm:w-auto justify-end border-t border-gray-100 sm:border-0 pt-4 sm:pt-0 mt-2 sm:mt-0">
              <button className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-[#11469A] hover:bg-gray-50 rounded-lg transition-colors">
                Preview
              </button>
              <button className="px-4 py-2 text-sm font-bold bg-[#11469A] text-white hover:bg-[#0d3678] rounded-lg transition-colors shadow-sm">
                Edit Content
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Pages;